import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProductContext } from "../App";

function DashBoard() {
  const product_context = useContext(ProductContext);
  const { setIsLoading, productType, alert, setAlert, setOrderTableCategory } =
    product_context;

  const [stock, setStock] = useState([]);
  const [order, setOrder] = useState([]);
  const [sort, setSort] = useState();
  const [orderDetails, setOrderDetails] = useState({});
  const [deliveryDetails, setDeliveryDetails] = useState({});
  const [dates, setDates] = useState({
    orders_year_list: [],
    orders_month_list: [],
  });

  const monthInString = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    let orderdetails = order?.sort((p1, p2) => {
      return new Date(p2.order_date) - new Date(p1.order_date);
    });
    setDates({
      orders_year_list: [...new Set(orderdetails.map((el) => el.year))],
      orders_month_list: [...new Set(orderdetails.map((el) => el.month))],
    });
  }, [order]);

  useEffect(() => {
    setSort({
      year: dates.orders_year_list[0],
      month: dates.orders_month_list[0],
    });
  }, [dates]);

  useEffect(() => {
    setIsLoading(true);
    try {
      axios
        .get(`${process.env.REACT_APP_SERVER_DOMAIN}/sell`)
        .then((res) => {
          setOrder(res.data.data);
        })
        .catch((err) => {
          setAlert({
            isOpen: true,
            message: "Something went Wrong",
            type: "danger",
          });
        });

      axios
        .get(`${process.env.REACT_APP_SERVER_DOMAIN}/products`)
        .then((res) => {
          setStock(res.data.data);
        })
        .catch((err) => {
          setAlert({
            isOpen: true,
            message: "Something Went Wrong",
            type: "danger",
          });
        });
      setIsLoading(false);
    } catch (error) {
      setAlert({
        isOpen: true,
        message: "Something Went Wrong",
        type: "danger",
      });
      setIsLoading(false);
    }
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIsLoading(true);
    let orders = sort
      ? order.filter((el) => el.year === sort?.year && el.month === sort?.month)
      : order;
    setOrderDetails({
      total: orders?.length,
      delivered: orders?.filter((el) => el.status === "done")?.length,
      returned: orders?.filter(
        (el) => el.status === "returned" || el.status === "returned/received"
      )?.length,
      exchanged: orders?.filter(
        (el) => el.status === "exchanged/received" || el.status === "exchanged"
      )?.length,
      canceled: orders?.filter((el) => el.status === "canceled")?.length,
    });
    console.log(orders);

    setDeliveryDetails({
      processing: orders?.filter((el) => el.status === "pending")?.length,
      out_for_delivery: orders?.filter((el) => el.status === "dispatched")
        ?.length,
      to_receive: orders?.filter((el) => el.status === "exchanged")?.length,
    });
    setIsLoading(false);
    // eslint-disable-next-line
  }, [sort, order]);

  let stockDetails = {};
  productType?.forEach((type) => {
    let quantity = 0;
    stock
      ?.filter((el) => el.item_type === type && el.quantity !== 0)
      ?.filter((el) => el.length !== 0)
      ?.map((el) => el.quantity)
      ?.forEach((el) => {
        quantity += el;
      });
    stockDetails[type] = quantity;
  });

  return (
    <div>
      <h3 className="text-center my-2">Dashboard</h3>

      <div className="sorting">
        <select
          onChange={(e) => {
            setSort({ ...sort, year: Number(e.target.value) });
          }}
          className="form-select sort"
          name="year"
        >
          {dates.orders_year_list?.map((year, i) => {
            return year === sort?.year ? (
              <option selected key={i} defaultValue={year}>
                {year}
              </option>
            ) : (
              <option key={i} value={year}>
                {year}
              </option>
            );
          })}
        </select>
        <select
          onChange={(e) => {
            setSort({ ...sort, month: Number(e.target.value) });
          }}
          className="form-select sort"
          name="year"
        >
          {dates.orders_month_list?.map((month, i) => {
            return month === sort?.month ? (
              <option selected key={i} defaultValue={month}>
                {monthInString[month - 1]}
              </option>
            ) : (
              <option key={i} value={month}>
                {monthInString[month - 1]}
              </option>
            );
          })}
        </select>
      </div>

      <hr />

      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center">
        <div className="d-flex flex-wrap">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Orders</h5>
              <Link
                onClick={() => {
                  setOrderTableCategory("ordertable");
                }}
                className="card-text"
                to="/orderstable"
              >
                <p>Total Orders: {orderDetails?.total}</p>
              </Link>
              <p className="card-text">
                Delivered Orders: {orderDetails?.delivered}
              </p>
              <p className="card-text">
                Returned Orders: {orderDetails?.returned}
              </p>
              <p className="card-text">
                Exchanged Orders: {orderDetails?.exchanged}
              </p>
              <p className="card-text">
                Canceled Orders: {orderDetails?.canceled}
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Delivery</h5>
              <Link
                onClick={() => {
                  setOrderTableCategory("processingtable");
                }}
                className="card-text"
                to="/orderstable"
              >
                <p>Processing Orders: {deliveryDetails?.processing}</p>
              </Link>
              <Link
                onClick={() => {
                  setOrderTableCategory("deliverytable");
                }}
                className="card-text"
                to="/orderstable"
              >
                <p>
                  Out for Delivery Orders: {deliveryDetails?.out_for_delivery}
                </p>
              </Link>
              <Link
                onClick={() => {
                  setOrderTableCategory("exchangetable");
                }}
                className="card-text"
                to="/orderstable"
              >
                <p>Items to Receive: {deliveryDetails?.to_receive}</p>
              </Link>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Stocks</h5>
            <h6 className="card-subtitle mb-2 text-muted">
              Categories: (In Stock)
            </h6>
            {productType?.map((type, i) => {
              return (
                <p key={i} className="card-text">
                  {type}: {stockDetails[type] || 0}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBoard;
